exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".member_box[data-v-d90e78b6]{padding:20px}", ""]);

// exports
